<script setup lang="ts">
import { computed } from 'vue'
import {
  getActivePersonaId,
  setActivePersonaId,
  MOCK_PERSONA_LIST,
  type MockPersonaId,
} from '@/mock-api-server/personas'
import { resetMockGivingPlan } from '@/mock-api-server/mock-plan-state'
import { clearMockOnboarding } from '@/mock-api-server/mock-onboarding-state'

const isMockApi = import.meta.env.MODE === 'mockapi'

const currentPersonaId = computed(() => getActivePersonaId())

const currentDescription = computed(
  () => MOCK_PERSONA_LIST.find((p) => p.id === currentPersonaId.value)?.description ?? ''
)

const onPersonaChange = (event: Event) => {
  const select = event.target as HTMLSelectElement
  const nextId = select.value as MockPersonaId
  if (nextId === currentPersonaId.value) return

  setActivePersonaId(nextId)
  resetMockGivingPlan()
  // Completed signup demos keep the onboarding donor in sessionStorage so the
  // dashboard does not snap back mid-flow; persona switch must clear it or
  // GET /me keeps returning that donor’s name instead of the selected persona.
  clearMockOnboarding()
  window.location.reload()
}
</script>

<template>
  <div
    v-if="isMockApi"
    class="sa-sidebar-mock-persona"
    role="region"
    aria-label="Mock donor persona"
  >
    <label class="sa-sidebar-mock-persona__label" for="mock-persona-select">
      Mock donor
    </label>
    <select
      id="mock-persona-select"
      class="sa-sidebar-mock-persona__select"
      :value="currentPersonaId"
      @change="onPersonaChange"
    >
      <option v-for="persona in MOCK_PERSONA_LIST" :key="persona.id" :value="persona.id">
        {{ persona.label }}
      </option>
    </select>
    <p class="sa-sidebar-mock-persona__hint">{{ currentDescription }}</p>
  </div>
</template>
